module.exports = __webpack_public_path__ + "img/sponsor_gallery_grid2.8b6c7ade.png";